import { all, fork } from 'redux-saga/effects';

import fetchWeatherWatcher from './weatherSaga';
// import fetchCitiesWatcher from './cities';

export default function* rootSaga() {
    yield all([
        fork(fetchWeatherWatcher), // In a thread
        // fork(fetchCitiesWatcher)
    ]);
}